<template>
    <div>
        <div class="mt-4 mb-8 space-y-2">
            <h2 class="text-3xl font-bold text-white">
                Reset your password
            </h2>
            <h3 class="text-sm text-gray-300">
                Enter the verification code you received by email.
            </h3>
        </div>

        <form action="#" @submit.prevent="onSubmit">
            <div class="space-y-6">
                <UFormGroup label="Verification code" :error="hasError && 'Invalid verification code'">
                    <UInput 
                        ref="codeInput" 
                        v-model="form.code"
                        type="text" 
                        size="xl" 
                        required
                    />
                </UFormGroup>
            </div>

            <UButton block type="submit" size="xl" :loading="loading" color="black" class="mt-8">
                Continue
            </UButton>
        </form>

        <div class="mt-6 text-center">
            <UButton to="/login" variant="link" color="black">
                Back to login
            </UButton>
        </div>
    </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'auth', middleware: 'guest' })
useHead({ title: 'Reset Password' })

const loading = ref<boolean>(false)
const hasError = ref<boolean>(false)
const codeInput = ref()

const form = ref({
    email: useRoute().query.email,
    code: '',
})

async function onSubmit() {
    loading.value = true

    try {
        const session = await $fetch('/api/auth/password/verify', {
            method: 'POST',
            body: form.value
        })

        if (session) {
            await useSupabaseClient().auth.setSession(session)
            navigateTo('/password/reset')
        } 
        else {
            showError()
        }
    } catch {
        showError()
    } finally {
        loading.value = false
    }
}

function showError() {
    codeInput.value?.$refs.input.focus()
    hasError.value = true
}
</script>
